<template>
  <div class="flex w-full">
    <article class="card">
      <div class="flex sm:flex-wrap md:flex-no-wrap ">
        <div class="card-hero-image">
          <img
            :src="avatarUrl"
            alt=""
            class="max-w-xs w-24"
          >
        </div>
        <div class="card-content">
          <small v-text="'MEMBER'" />
          <h3
            class="-mb-2"
            v-text="`${name} Requested Access`"
          />
          <div
            class="mt-2 text-sm text-grey-dark"
            v-text="date"
          />
          <a
            :href="actionLink"
            class="mt-4"
            v-text="'Review Requests'"
          />
        </div>
      </div>
    </article>
  </div>
</template>

<script type="text/babel">
import ActivityItemMixin from '../../mixins/ActivityItemMixin'

export default {
  name: 'AccessRequestHasBeenCreated',
  mixins: [ActivityItemMixin],
  computed: {
    actionLink() {
      return this.$urlGenerator.active('members/approve')
    },
  },
}
</script>
